<template>
  <div>
    <el-button type="primary" @click="addAliquotGroup" style="margin-bottom: 20px">Novo Grupo</el-button>
    <el-form :model="aliquotGroups" ref="aliquotGroups" label-position="top">
      <el-collapse v-model="activeGroups">
        <el-collapse-item v-for="(group, groupIndex) in aliquotGroups" :key="groupIndex" :name="groupIndex">
          <template #title>
            <el-row :gutter="20">
              <el-col :span="6">
                <span>{{ group.aliquot || 'Enter Aliquot Name' }}</span>
              </el-col>
              <el-col :span="8" class="text-right">
                <el-button type="danger" @click.stop="removeAliquotGroup(groupIndex)" icon="el-icon-delete" circle />
              </el-col>
            </el-row>
          </template>
          <el-input v-model="group.aliquot" placeholder="Enter Aliquot Name" class="aliquot-input" v-if="!hasPriceRanges(group)" />
          <el-button type="primary" @click="addPriceRange(groupIndex)" style="float: right;margin-top: -5px" icon="el-icon-plus" circle />
          <div v-for="(range, rangeIndex) in group.aliquotList" :key="rangeIndex" class="price-range-row">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('origem')" :prop="'aliquotGroups.' + groupIndex + '.aliquotList.' + rangeIndex + '.aliquot'">
                  <el-input v-model="group.aliquot" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('destino')" :prop="'aliquotGroups.' + groupIndex + '.aliquotList.' + rangeIndex + '.destiny'" :rules="[
                  { required: true, message: $t('campo-obrigatorio'), trigger: 'blur' },
                  { type: 'string', message: $t('estado'), trigger: 'blur' }
                ]">
                  <el-input 
                    v-model="range.destiny"
                    class="w-full"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('valor-a-cobrar') + ' (%)'" :prop="'aliquotGroups.' + groupIndex + '.aliquotList.' + rangeIndex + '.aliquotValue'" :rules="[
                { required: true, message: $t('campo-obrigatorio'), trigger: 'blur' },
                { type: 'number', message: $t('numero'), trigger: 'blur' }
              ]">
                <el-input-number 
                  v-model="range.aliquotValue"
                  :min="1"
                  :controls="false"
                  class="w-full"/>
              </el-form-item>
              </el-col>
              <el-col :span="6" class="centered-col">
                <el-button type="danger" icon="el-icon-delete" @click="removePriceRange(groupIndex, rangeIndex)" circle />
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ShippingAddFormAliquotPrice',
  data() {
    return {
      aliquotGroups: [],
      activeGroups: []
    }
  },
  computed: {
    hasPriceRanges() {
      return (group) => group.aliquotList.length > 0;
    }
  },
  methods: {
    addAliquotGroup() {
      this.aliquotGroups.push({
        aliquot: '',
        aliquotList: []
      });
    },
    removeAliquotGroup(groupIndex) {
      this.aliquotGroups.splice(groupIndex, 1);
    },
    addPriceRange(groupIndex) {
      this.aliquotGroups[groupIndex].aliquotList.push({
        destiny: '',
        aliquotValue: 0,
      });
    },
    removePriceRange(groupIndex, rangeIndex) {
      this.aliquotGroups[groupIndex].aliquotList.splice(rangeIndex, 1);
    },
    setData(data) {
      const { aliquotRules } = data;
      if (aliquotRules) {
        this.aliquotGroups = aliquotRules.map(rule => ({
          aliquot: rule.aliquot,
          aliquotList: rule.aliquotList
        }));
      }
    },
    data() {
      return {
        aliquotRules: this.aliquotGroups.map(group => ({
          aliquot: group.aliquot,
          aliquotList: [...group.aliquotList]
        }))
      };
    }
  }
}
</script>

<style scoped>
.price-range-row {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}

.centered-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 90px;
}

.aliquot-group {
  margin-bottom: 20px;
}

.aliquot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.aliquot-input {
  width: 80%;
}

.aliquot-label {
  width: 80%;
  padding: 8px 12px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  background-color: #F5F7FA;
}
</style>
